import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  PaymentVoucherUpdate,
  PaymentVoucherCreate,
  GetApproveGVs,
  GetApprovedPVs,
  BankDetailList,
  GeneratePaymentVoucherNo,
  ApproveExpenseList,
  DivisionList,
  LedgerName,
  ApproveSolistapi,
  fetchJournalVouchersBySupplier,
  fetchJournalVouchersByImprest,
  fetchPurchaseVouchersBySupplier,
  fetchJournalVouchersByAdvanceWorker,

} from "../../../Services/Services";
import {
  Box,
  TextField,
  Button,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
  Card,
  CardContent,
  Divider,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Checkbox,
  useMediaQuery, useTheme

} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { debounce } from "lodash";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router";

const PaymentVoucherForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const location = useLocation();
  const isEditMode = location.state?.editMode || false;
  const editData = location.state?.voucherData || null;
 
  const navigate = useNavigate();

  // ✅ SINGLE ENTRY STATE
  const [paymentVoucherNo, setPaymentVoucherNo] = useState("");
  const [paymentNumber, setPaymentNumber] = useState("");
  const [party, setParty] = useState(null);
  const [partyName, setPartyName] = useState("");
  const [project, setProject] = useState("");
  const [projectName, setProjectName] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [supplierName, setSupplierName] = useState("");
  const [imprestAccount, setImprestAccount] = useState(null);
  const [imprestAccountName, setImprestAccountName] = useState("");
  const [advanceWorker, setAdvanceWorker] = useState(null);
  const [advanceWorkerName, setAdvanceWorkerName] = useState("");
  const [ledgerType, setLedgerType] = useState("");
  const [division, setDivision] = useState("");
  const [divisionName, setDivisionName] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [methodOfPayment, setMethodOfPayment] = useState("");
  const [voucherType, setVoucherType] = useState("");
  const [transporter, setTransporter] = useState(null);
  const [transporterName, setTransporterName] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [againstReferenceAmount, setAgainstReferenceAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [description, setDescription] = useState("");
  const [recommended_by, setRecommendedBy] = useState("");
  const [bank, setBank] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [narration, setNarration] = useState("");
  const [expense, setExpense] = useState(null); // ✅ EXPENSE STATE
  const [expenseName, setExpenseName] = useState(""); // ✅ EXPENSE NAME STATE

  // ✅ NEW STATE FOR NEFT/RTGS CHECKBOX & DETAILS
  const [showNeftRtgsDetails, setShowNeftRtgsDetails] = useState(false);
  const [neftRtgsAccountNumber, setNeftRtgsAccountNumber] = useState("");
  const [neftRtgsIfscCode, setNeftRtgsIfscCode] = useState("");
  const [neftRtgsBankName, setNeftRtgsBankName] = useState("");
  const [neftRtgsBranchName, setNeftRtgsBranchName] = useState("");
  // ✅ Add this state at the top with other states
  const [isNeftRtgs, setIsNeftRtgs] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [currentEditId, setCurrentEditId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [expenseRows, setExpenseRows] = useState([{ expense: "", amount: "" }]);
  const [expenses, setExpenses] = useState([]);
  const [purchaseVouchers, setPurchaseVouchers] = useState([]);
  const [journalVouchers, setJournalVouchers] = useState([]);
  const [allJournalVouchers, setAllJournalVouchers] = useState([]);
  const [allPurchaseVouchers, setAllPurchaseVouchers] = useState([]);
  const [selectedVouchers, setSelectedVouchers] = useState([]);
  const [projectLists, setProjectLists] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [divisionLists, setDivisionLists] = useState([]);
  const [transporters, setTransporters] = useState([]);
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [ledgerInputValue, setLedgerInputValue] = useState("");
  const [selectedLedger, setSelectedLedger] = useState(null);

  // ✅ CACHE MECHANISM
  const ledgerCache = useRef(new Map());

  // ✅ OPTIMIZED LEDGER SEARCH WITH CACHE
  const fetchLedgersWithSearch = async (searchText = "") => {
    const cacheKey = searchText.toLowerCase();
    if (ledgerCache.current.has(cacheKey)) {
      setLedgerOptions(ledgerCache.current.get(cacheKey));
      setLedgerLoading(false);
      return;
    }

    setLedgerLoading(true);
    try {
      const response = await LedgerName({ search: searchText });

      let data = [];
      if (response?.results?.data) {
        data = response.results.data;
      } else if (response?.data) {
        data = response.data;
      } else if (Array.isArray(response)) {
        data = response;
      }

      ledgerCache.current.set(cacheKey, data);
      setLedgerOptions(data);
      setLedgers(data);
    } catch (error) {
      console.error("Error fetching ledgers:", error);
      setLedgerOptions([]);
    } finally {
      setLedgerLoading(false);
    }
  };

  // ✅ DEBOUNCED SEARCH FUNCTION
  const debouncedLedgerSearch = useCallback(
    debounce((searchText) => {
      if (searchText.trim().length >= 2) {
        fetchLedgersWithSearch(searchText);
      } else if (searchText.trim().length === 0) {
        fetchLedgersWithSearch("");
      }
    }, 500),
    []
  );

  const handleLedgerChange = (ledger) => {
    // ledger may be null when cleared
    setSelectedLedger(ledger); // store it so other handlers can use it

    // clear ledger related errors
    setFormErrors(prev => {
      const updated = { ...prev };
      delete updated.ledger;
      return updated;
    });

    if (ledger) {
      // Reset other fields
      setParty(null); setPartyName("");
      setSupplier(null); setSupplierName("");
      setImprestAccount(null); setImprestAccountName("");
      setAdvanceWorker(null); setAdvanceWorkerName("");
      setTransporter(null); setTransporterName("");
      setExpense(null); setExpenseName("");
      setLedgerType(ledger.type);
      setVoucherType("");

      // If ledger has bank details, populate NEFT/RTGS fields (but don't force-show checkbox)
      if (ledger.account_no || ledger.ifsc_code || ledger.bank_name || ledger.branch_name) {
        setNeftRtgsAccountNumber(ledger.account_no || "");
        setNeftRtgsIfscCode(ledger.ifsc_code || "");
        setNeftRtgsBankName(ledger.bank_name || "");
        setNeftRtgsBranchName(ledger.branch_name || "");
        // optional: you may want to also auto-check/show:
        // setShowNeftRtgsDetails(true); setIsNeftRtgs(true);
      } else {
        // ledger has no bank info -> clear fields
        setNeftRtgsAccountNumber("");
        setNeftRtgsIfscCode("");
        setNeftRtgsBankName("");
        setNeftRtgsBranchName("");
        // keep checkbox state as-is (don't forcibly hide)
      }

      // set other specific ledger fields
      switch (ledger.type) {
        case "Party":
          setParty(ledger.id); setPartyName(ledger.name);
          break;
        case "Supplier":
          setSupplier(ledger.id); setSupplierName(ledger.name);
          break;
        case "Imprest":
          setImprestAccount(ledger.id); setImprestAccountName(ledger.name);
          break;
        case "AdvanceWorker":
          setAdvanceWorker(ledger.id); setAdvanceWorkerName(ledger.name);
          break;
        case "Transporter":
          setTransporter(ledger.id); setTransporterName(ledger.name);
          break;
        case "Expense":
          setExpense(ledger.id); setExpenseName(ledger.name);
          break;
        default:
          break;
      }
    } else {
      // cleared selection -> reset all ledger-related state
      setParty(null); setPartyName("");
      setSupplier(null); setSupplierName("");
      setImprestAccount(null); setImprestAccountName("");
      setAdvanceWorker(null); setAdvanceWorkerName("");
      setTransporter(null); setTransporterName("");
      setExpense(null); setExpenseName("");
      setLedgerType("");


      // clear NEFT/RTGS details & hide checkbox
      setShowNeftRtgsDetails(false);
      setIsNeftRtgs(false);
      setNeftRtgsAccountNumber("");
      setNeftRtgsIfscCode("");
      setNeftRtgsBankName("");
      setNeftRtgsBranchName("");
    }
  };
  // ✅ SIMPLIFIED PAYMENT METHOD CHANGE HANDLER
  const handlePaymentMethodChange = (methodType) => {
    setFormErrors(prev => {
      const updated = { ...prev };
      delete updated.method_of_payment;
      return updated;
    });

    setMethodOfPayment(methodType);
    setVoucherType("");
    setTotalAmount("");

    // ✅ Against Reference के लिए automatic voucher type set करें
    if (methodType === "against_reference") {
      if (ledgerType === "Imprest" && imprestAccount) {
        setVoucherType("journal");
        fetchJournalVouchersByImprestAPI(imprestAccount);
      } else if (ledgerType === "AdvanceWorker" && advanceWorker) {
        setVoucherType("journal");
        fetchJournalVouchersByAdvanceWorkerAPI(advanceWorker);
      }
    }
  };

  // ✅ SIMPLIFIED VOUCHER TYPE CHANGE HANDLER
  const handleVoucherTypeChange = (voucherTypeValue) => {
    setVoucherType(voucherTypeValue);

    if (voucherTypeValue !== "expense") {
      setExpenseRows([{ expense: "", amount: "" }]);
    }

    if (voucherTypeValue === "purchase") {
      if (ledgerType === "Supplier" && methodOfPayment === "against_reference" && supplier) {
        fetchPurchaseVouchersBySupplierAPI(supplier);
      } else {
        setPurchaseVouchers([...allPurchaseVouchers]);
        setSelectedVouchers([...allPurchaseVouchers]);
      }
    } else if (voucherTypeValue === "journal") {
      if (ledgerType === "Supplier" && methodOfPayment === "against_reference" && supplier) {
        fetchJournalVouchersBySupplierAPI(supplier);
      } else if (ledgerType === "Imprest" && methodOfPayment === "against_reference" && imprestAccount) {
        fetchJournalVouchersByImprestAPI(imprestAccount);
      }
    } else {
      setSelectedVouchers([]);
    }
  };

  // ✅ SIMPLIFIED DIVISION CHANGE
  const handleDivisionChange = (selectedDivision) => {
    if (selectedDivision) {
      setDivision(selectedDivision.id);
      setDivisionName(selectedDivision.name);
    } else {
      setDivision("");
      setDivisionName("");
    }
  };

  // ✅ SIMPLIFIED PROJECT CHANGE
  const handleProjectChange = (selectedProject) => {
    if (selectedProject) {
      setProject(selectedProject.id);
      setProjectName(selectedProject.name);
    } else {
      setProject("");
      setProjectName("");
    }
  };


  const handleNeftRtgsCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setShowNeftRtgsDetails(isChecked);
    setIsNeftRtgs(isChecked);

    if (isChecked && selectedLedger) {
      // ✅ Fill NEFT/RTGS details again from selected ledger if available
      setNeftRtgsAccountNumber(selectedLedger.account_no || "");
      setNeftRtgsIfscCode(selectedLedger.ifsc_code || "");
      setNeftRtgsBankName(selectedLedger.bank_name || "");
      setNeftRtgsBranchName(selectedLedger.branch_name || "");
    } else if (!isChecked) {
      // ✅ Clear fields on uncheck
      setNeftRtgsAccountNumber("");
      setNeftRtgsIfscCode("");
      setNeftRtgsBankName("");
      setNeftRtgsBranchName("");
    }
  };



  const fetchJournalVouchersByAdvanceWorkerAPI = async (advanceWorkerId) => {
    try {
      const response = await fetchJournalVouchersByAdvanceWorker(advanceWorkerId);
      const jvData = Array.isArray(response) ? response : response?.results || response?.data || [];

      const filteredJournalVouchers = jvData.map(jv => ({
        id: jv.gen_voucher_no,
        voucher_no: jv.gen_number || jv.voucher_number,
        bill_no: jv.bill_no,
        total_amount: parseFloat(jv.sub_vouchers?.[0]?.amount) || parseFloat(jv.total_amount) || 0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal"
      }));

      setJournalVouchers(filteredJournalVouchers);
      setSelectedVouchers(filteredJournalVouchers);

      if (filteredJournalVouchers.length === 0) {
        toast.info("No journal vouchers found for this advance worker");
      } else {
        toast.success(`Found ${filteredJournalVouchers.length} journal voucher(s)`);
      }
    } catch (error) {
      console.error("Error fetching advance worker journal vouchers:", error);
      toast.error("Failed to fetch journal vouchers");
    }
  };

  const handleVoucherCheckboxChange = (voucherIndex, isChecked) => {
    setSelectedVouchers(prev => {
      const updated = [...prev];
      const voucher = updated[voucherIndex];
      if (isChecked) {
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: voucher.remaining_amount.toString()
        };
        toast.success(`₹${voucher.remaining_amount.toFixed(2)} added to adjust amount`);
      } else {
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: ""
        };
        toast.info("Adjust amount cleared");
      }
      return updated;
    });
  };

  const getVoucherTypeOptions = (ledgerType) => {
    switch (ledgerType) {
      case "Supplier":
        return [
          { value: "journal", label: "Journal Voucher" },
          { value: "purchase", label: "Purchase Voucher" },
        ];
      case "Imprest":
        return [
          { value: "journal", label: "Journal Voucher" },
        ];
      case "AdvanceWorker":
        return [
          { value: "journal", label: "Journal Voucher" },
        ];
      default:
        return [];
    }
  };

  const fetchPurchaseVouchersBySupplierAPI = async (supplierId) => {
    try {
      const response = await fetchPurchaseVouchersBySupplier(supplierId);
      const pvData = Array.isArray(response) ? response : response?.results || response?.data || [];

      const filteredPurchaseVouchers = pvData.map(pv => ({
        id: pv.purchase_voucher_no,
        voucher_no: pv.purchase_number || pv.voucher_number,
        total_amount: parseFloat(pv.total_amount) || 0,
        remaining_amount: parseFloat(pv.balance_amount) || parseFloat(pv.total_amount) || 0,
        paid_amount: "",
        type: "purchase"
      }));

      setPurchaseVouchers(filteredPurchaseVouchers);
      setSelectedVouchers(filteredPurchaseVouchers);
      toast.success(`Found ${filteredPurchaseVouchers.length} purchase voucher(s)`);
    } catch (error) {
      console.error("Error fetching purchase vouchers:", error);
      toast.error("Failed to fetch purchase vouchers");
    }
  };

  const fetchJournalVouchersBySupplierAPI = async (supplierId) => {
    try {
      const response = await fetchJournalVouchersBySupplier(supplierId);
      const jvData = Array.isArray(response) ? response : response?.results || response?.data || [];

      const filteredJournalVouchers = jvData.map(jv => ({
        id: jv.gen_voucher_no,
        voucher_no: jv.gen_number || jv.voucher_number,
        bill_no: jv.bill_no,
        total_amount: parseFloat(jv.grandtotal) || parseFloat(jv.sub_vouchers?.[0]?.amount) || parseFloat(jv.total_amount) || 0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal"
      }));

      setJournalVouchers(filteredJournalVouchers);
      setSelectedVouchers(filteredJournalVouchers);

      if (filteredJournalVouchers.length === 0) {
        toast.info("No journal vouchers found for this supplier");
      } else {
        toast.success(`Found ${filteredJournalVouchers.length} journal voucher(s)`);
      }
    } catch (error) {
      console.error("Error fetching journal vouchers:", error);
      toast.error("Failed to fetch journal vouchers");
    }
  };

  const fetchJournalVouchersByImprestAPI = async (imprestId) => {
    try {
      const response = await fetchJournalVouchersByImprest(imprestId);
      const jvData = Array.isArray(response) ? response : response?.results || response?.data || [];

      const filteredJournalVouchers = jvData.map(jv => ({
        id: jv.gen_voucher_no,
        voucher_no: jv.gen_number || jv.voucher_number,
        total_amount: parseFloat(jv.grandtotal) || parseFloat(jv.sub_vouchers?.[0]?.amount) || parseFloat(jv.total_amount) || 0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal"
      }));

      setJournalVouchers(filteredJournalVouchers);
      setSelectedVouchers(filteredJournalVouchers);
      toast.success(`Found ${filteredJournalVouchers.length} journal voucher(s)`);
    } catch (error) {
      console.error("Error fetching imprest journal vouchers:", error);
      toast.error("Failed to fetch journal vouchers");
    }
  };

  const addExpenseRow = () => {
    if (expenseRows.length >= 5) {
      toast.warning("Maximum 5 expense rows allowed");
      return;
    }
    setExpenseRows([...expenseRows, { expense: "", amount: "" }]);
  };

  const removeExpenseRow = (index) => {
    if (expenseRows.length > 1) {
      setExpenseRows(expenseRows.filter((_, i) => i !== index));
    }
  };

  const handleExpenseRowChange = (index, field, value) => {
    setExpenseRows(prev => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const calculateTotalAmount = () => {
    return expenseRows.reduce((total, row) => {
      return total + (parseFloat(row.amount) || 0);
    }, 0).toFixed(2);
  };

  const handleAdjustAmountChange = (voucherIndex, adjustAmount) => {
    setSelectedVouchers(prev => {
      const updated = [...prev];
      const voucher = updated[voucherIndex];
      const remainingAmount = parseFloat(voucher.remaining_amount) || 0;
      const adjust = parseFloat(adjustAmount) || 0;
      if (adjust > remainingAmount) {
        toast.warning(`Adjust amount cannot exceed remaining amount (₹${remainingAmount.toFixed(2)})`);
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: remainingAmount.toFixed(2)
        };
      } else {
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: adjustAmount
        };
      }
      return updated;
    });
  };

  const calculateTotalAdjustAmount = () => {
    return selectedVouchers.reduce((total, voucher) => {
      return total + (parseFloat(voucher.paid_amount) || 0);
    }, 0).toFixed(2);
  };

  useEffect(() => {
    fetchAllData();
    if (!isEditMode) {
      generateVoucherNumber();
    }
    fetchLedgersWithSearch("");
  }, []);

  useEffect(() => {
    return () => {
      ledgerCache.current.clear();
    };
  }, []);

  const fetchAllData = async () => {
    try {
      const [bank, divisions, expenseData, purchaseVoucher, journalVoucher, projects] = await Promise.all([
        BankDetailList(),
        DivisionList(),
        ApproveExpenseList(),
        GetApprovedPVs(),
        GetApproveGVs(),
        ApproveSolistapi(),
      ]);

      const projectsData = Array.isArray(projects) ? projects : projects?.results || projects?.data || [];
      setProjectLists(projectsData.map(proj => ({
        id: proj.id,
        name: proj.project_name || proj.name || `Project ${proj.id}`
      })));
      setBankDetails(Array.isArray(bank) ? bank : bank?.results || []);
      setExpenses(Array.isArray(expenseData) ? expenseData : expenseData?.results || []);

      const pvData = Array.isArray(purchaseVoucher) ? purchaseVoucher : purchaseVoucher?.results || [];
      const allPVData = pvData.map(pv => ({
        id: pv.id || pv.purchase_id || pv.purchase_voucher_no,
        voucher_no: pv.purchase_number,
        total_amount: parseFloat(pv.total_amount) || 0,
        remaining_amount: parseFloat(pv.balance_amount) || parseFloat(pv.total_amount) || 0,
        paid_amount: "",
        type: "purchase"
      }));
      setAllPurchaseVouchers(allPVData);
      setPurchaseVouchers(allPVData);

      const jvData = Array.isArray(journalVoucher) ? journalVoucher : journalVoucher?.results || [];
      const allJVData = jvData.map(jv => ({
        id: jv.id || jv.journal_id || jv.gen_voucher_no,
        voucher_no: jv.gen_number,
        total_amount: parseFloat(jv.grandtotal) || parseFloat(jv.sub_vouchers?.[0]?.amount) || 0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal"
      }));
      setAllJournalVouchers(allJVData);
      setJournalVouchers(allJVData);

      const divisionsArray = Array.isArray(divisions) ? divisions : divisions?.results || [];
      setDivisionLists(divisionsArray.map((div) => ({ id: div.division_id, name: div.division })));

    } catch (error) {
      console.error("Data fetch error:", error);
      toast.error("Error fetching initial data");
      setBankDetails([]);
      setDivisionLists([]);
      setExpenses([]);
      setPurchaseVouchers([]);
      setJournalVouchers([]);
      setAllJournalVouchers([]);
      setAllPurchaseVouchers([]);
      setProjectLists([]);
    }
  };

  const generateVoucherNumber = async () => {
    try {
      const data = await GeneratePaymentVoucherNo();
      if (data && data.payment_voucher_no) {
        setPaymentNumber(data.payment_voucher_no);
      }
    } catch (error) {
      console.error("Error generating voucher number:", error);
      toast.error("Failed to generate voucher number");
    }
  };



  // useEffect(() => {
  //   if (isEditMode && editData) {
  //     setEditMode(true);
  //     setCurrentEditId(editData.payment_voucher_no);

  //     let ledgerTypeValue = "";
  //     if (editData.party) ledgerTypeValue = "Party";
  //     else if (editData.supplier) ledgerTypeValue = "Supplier";
  //     else if (editData.imprest_account) ledgerTypeValue = "Imprest";
  //     else if (editData.advance_worker) ledgerTypeValue = "AdvanceWorker";
  //     else if (editData.expense) ledgerTypeValue = "Expense";
  //     else if (editData.transporter) ledgerTypeValue = "Transporter";

  //     setPaymentVoucherNo(editData.payment_voucher_no || "");
  //     setPaymentNumber(editData.payment_number || "");
  //     setParty(editData.party || null);
  //     setPartyName(editData.party_name || "");
  //     setSupplier(editData.supplier || null);
  //     setSupplierName(editData.supplier_name || "");
  //     setImprestAccount(editData.imprest_account || null);
  //     setImprestAccountName(editData.imprest_account_name || "");
  //     setAdvanceWorker(editData.advance_worker || null);
  //     setAdvanceWorkerName(editData.advance_worker_name || "");
  //     setExpense(editData.expense || null);
  //     setExpenseName(editData.expense_name || "");
  //     setProject(editData.project || "");
  //     setProjectName(editData.project_name || "");
  //     setLedgerType(ledgerTypeValue);
  //     setDivision(editData.division || "");
  //     setDivisionName(editData.division_name || "");
  //     setMethodOfPayment(editData.method_of_payment || "");
  //     setChequeDate(editData.cheque_date || "");
  //     setPaymentDate(editData.payment_date || "");
  //     setVoucherType(editData.voucher_type || "");
  //     setTransporter(editData.transporter || null);
  //     setTransporterName(editData.transporter_name || "");
  //     setTotalAmount(editData.total_amount || "");
  //     setPaymentMode(editData.payment_mode || "");
  //     setDescription(editData.description || "");
  //     setRecommendedBy(editData.recommended_by || "");
  //     setBank(editData.bank || "");
  //     setNarration(editData.narration || "");

  //     // ✅ Load NEFT/RTGS details
  //     if (editData.is_neft_rtgs) {
  //       setIsNeftRtgs(true);
  //       setShowNeftRtgsDetails(true);
  //       setNeftRtgsAccountNumber(editData.account_number || ""); // ✅ Changed from account_no
  //       setNeftRtgsIfscCode(editData.ifsc_code || "");
  //       setNeftRtgsBankName(editData.bank_name_fk || ""); // ✅ Changed from bank_name
  //       setNeftRtgsBranchName(editData.branch_name || "");
  //     } else {
  //       setIsNeftRtgs(false);
  //       setShowNeftRtgsDetails(false);
  //       setNeftRtgsAccountNumber("");
  //       setNeftRtgsIfscCode("");
  //       setNeftRtgsBankName("");
  //       setNeftRtgsBranchName("");
  //     }

  //     // ✅ FIXED: Handle payment_subvoucher array for purchase/journal vouchers
  //     if ((editData.voucher_type === 'purchase' || editData.voucher_type === 'journal')
  //       && editData.payment_subvoucher && editData.payment_subvoucher.length > 0) {

  //       const voucherData = editData.payment_subvoucher.map(ref => ({
  //         id: ref.purchase_voucher || ref.journal_voucher,
  //         voucher_no: ref.purchase_voucher_no || ref.journal_voucher_no || "",
  //         total_amount: ref.journal_voucher ? (parseFloat(ref.journal_grandtotal) || parseFloat(ref.journal_total_amount) || 0) : (parseFloat(ref.purchase_total_amount) || 0),
  //         bill_no: ref.journal_bill_no || "",
  //         remaining_amount: parseFloat(ref.purchase_rem_amount || ref.journal_rem_amount || 0),
  //         paid_amount: parseFloat(ref.paid_amount || 0).toString(),
  //         type: ref.purchase_voucher ? "purchase" : "journal"
  //       }));

  //       setSelectedVouchers(voucherData);

  //       // ✅ Also set in appropriate state based on voucher type
  //       if (editData.voucher_type === 'purchase') {
  //         setPurchaseVouchers(voucherData);
  //       } else if (editData.voucher_type === 'journal') {
  //         setJournalVouchers(voucherData);
  //       }
  //     }

  //     // ✅ Handle expense rows (if applicable - though not in your current data)


  //     // ✅ Set selected ledger for autocomplete
  //     if (ledgerTypeValue && ledgers.length > 0) {
  //       const matchingLedger = ledgers.find(l => {
  //         if (ledgerTypeValue === "Party" && editData.party) return l.id === editData.party && l.type === "Party";
  //         if (ledgerTypeValue === "Supplier" && editData.supplier) return l.id === editData.supplier && l.type === "Supplier";
  //         if (ledgerTypeValue === "Imprest" && editData.imprest_account) return l.id === editData.imprest_account && l.type === "Imprest";
  //         if (ledgerTypeValue === "AdvanceWorker" && editData.advance_worker) return l.id === editData.advance_worker && l.type === "AdvanceWorker";
  //         if (ledgerTypeValue === "Transporter" && editData.transporter) return l.id === editData.transporter && l.type === "Transporter";
  //         if (ledgerTypeValue === "Expense" && editData.expense) return l.id === editData.expense && l.type === "Expense";
  //         return false;
  //       });

  //       if (matchingLedger) {
  //         setSelectedLedger(matchingLedger);
  //         setLedgerInputValue(matchingLedger.name || "");
  //       } else {
  //         // ✅ Agar ledger list mein nahi mila toh manually create karein
  //         const manualLedger = {
  //           id: editData.expense,
  //           name: editData.expense_name,
  //           type: "Expense"
  //         };
  //         setSelectedLedger(manualLedger);
  //         setLedgerInputValue(editData.expense_name || "");
  //       }
  //     }
  //   } else {
  //     setEditMode(false);
  //     setCurrentEditId(null);
  //   }
  // }, [isEditMode, editData, ledgers]);  // ✅ Added ledgers dependency


  useEffect(() => {
    if (isEditMode && editData) {
      setEditMode(true);
      setCurrentEditId(editData.payment_voucher_no);

      let ledgerTypeValue = "";
      if (editData.party) ledgerTypeValue = "Party";
      else if (editData.supplier) ledgerTypeValue = "Supplier";
      else if (editData.imprest_account) ledgerTypeValue = "Imprest";
      else if (editData.advance_worker) ledgerTypeValue = "AdvanceWorker";
      else if (editData.expense) ledgerTypeValue = "Expense";
      else if (editData.transporter) ledgerTypeValue = "Transporter";

      setPaymentVoucherNo(editData.payment_voucher_no || "");
      setPaymentNumber(editData.payment_number || "");
      setParty(editData.party || null);
      setPartyName(editData.party_name || "");
      setSupplier(editData.supplier || null);
      setSupplierName(editData.supplier_name || "");
      setImprestAccount(editData.imprest_account || null);
      setImprestAccountName(editData.imprest_account_name || "");
      setAdvanceWorker(editData.advance_worker || null);
      setAdvanceWorkerName(editData.advance_worker_name || "");
      setExpense(editData.expense || null);
      setExpenseName(editData.expense_name || "");
      setProject(editData.project || "");
      setProjectName(editData.project_name || "");
      setLedgerType(ledgerTypeValue);
      setDivision(editData.division || "");
      setDivisionName(editData.division_name || "");
      setMethodOfPayment(editData.method_of_payment || "");
      setChequeDate(editData.cheque_date || "");
      setPaymentDate(editData.payment_date || "");
      setVoucherType(editData.voucher_type || "");
      setTransporter(editData.transporter || null);
      setTransporterName(editData.transporter_name || "");
      setTotalAmount(editData.total_amount || "");
      setPaymentMode(editData.payment_mode || "");
      setDescription(editData.description || "");
      setRecommendedBy(editData.recommended_by || "");
      setBank(editData.bank || "");
      setNarration(editData.narration || "");

      if (editData.is_neft_rtgs) {
        setIsNeftRtgs(true);
        setShowNeftRtgsDetails(true);
        setNeftRtgsAccountNumber(editData.account_number || "");
        setNeftRtgsIfscCode(editData.ifsc_code || "");
        setNeftRtgsBankName(editData.bank_name_fk || "");
        setNeftRtgsBranchName(editData.branch_name || "");
      } else {
        setIsNeftRtgs(false);
        setShowNeftRtgsDetails(false);
        setNeftRtgsAccountNumber("");
        setNeftRtgsIfscCode("");
        setNeftRtgsBankName("");
        setNeftRtgsBranchName("");
      }

      if ((editData.voucher_type === 'purchase' || editData.voucher_type === 'journal')
        && editData.payment_subvoucher && editData.payment_subvoucher.length > 0) {

        const voucherData = editData.payment_subvoucher.map(ref => ({
          id: ref.purchase_voucher || ref.journal_voucher,
          voucher_no: ref.purchase_voucher_no || ref.journal_voucher_no || "",
          total_amount: ref.journal_voucher ? (parseFloat(ref.journal_grandtotal) || parseFloat(ref.journal_total_amount) || 0) : (parseFloat(ref.purchase_total_amount) || 0),
          bill_no: ref.journal_bill_no || "",
          remaining_amount: parseFloat(ref.purchase_rem_amount || ref.journal_rem_amount || 0),
          paid_amount: parseFloat(ref.paid_amount || 0).toString(),
          type: ref.purchase_voucher ? "purchase" : "journal"
        }));

        setSelectedVouchers(voucherData);

        if (editData.voucher_type === 'purchase') {
          setPurchaseVouchers(voucherData);
        } else if (editData.voucher_type === 'journal') {
          setJournalVouchers(voucherData);
        }
      }

      // ✅ IMPROVED: Create manual ledger for ALL types if not found
      if (ledgerTypeValue && ledgers.length > 0) {
        const matchingLedger = ledgers.find(l => {
          if (ledgerTypeValue === "Party" && editData.party) return l.id === editData.party && l.type === "Party";
          if (ledgerTypeValue === "Supplier" && editData.supplier) return l.id === editData.supplier && l.type === "Supplier";
          if (ledgerTypeValue === "Imprest" && editData.imprest_account) return l.id === editData.imprest_account && l.type === "Imprest";
          if (ledgerTypeValue === "AdvanceWorker" && editData.advance_worker) return l.id === editData.advance_worker && l.type === "AdvanceWorker";
          if (ledgerTypeValue === "Transporter" && editData.transporter) return l.id === editData.transporter && l.type === "Transporter";
          if (ledgerTypeValue === "Expense" && editData.expense) return l.id === editData.expense && l.type === "Expense";
          return false;
        });

        if (matchingLedger) {
          setSelectedLedger(matchingLedger);
          setLedgerInputValue(matchingLedger.name || "");
        } else {
          // ✅ Create manual ledger for ALL types
          let manualLedger = null;

          if (ledgerTypeValue === "Party" && editData.party) {
            manualLedger = { id: editData.party, name: editData.party_name, type: "Party" };
          } else if (ledgerTypeValue === "Supplier" && editData.supplier) {
            manualLedger = { id: editData.supplier, name: editData.supplier_name, type: "Supplier" };
          } else if (ledgerTypeValue === "Imprest" && editData.imprest_account) {
            manualLedger = { id: editData.imprest_account, name: editData.imprest_account_name, type: "Imprest" };
          } else if (ledgerTypeValue === "AdvanceWorker" && editData.advance_worker) {
            manualLedger = { id: editData.advance_worker, name: editData.advance_worker_name, type: "AdvanceWorker" };
          } else if (ledgerTypeValue === "Transporter" && editData.transporter) {
            manualLedger = { id: editData.transporter, name: editData.transporter_name, type: "Transporter" };
          } else if (ledgerTypeValue === "Expense" && editData.expense) {
            manualLedger = { id: editData.expense, name: editData.expense_name, type: "Expense" };
          }

          if (manualLedger) {
            setSelectedLedger(manualLedger);
            setLedgerInputValue(manualLedger.name || "");
          }
        }
      }
    } else {
      setEditMode(false);
      setCurrentEditId(null);
    }
  }, [isEditMode, editData, ledgers]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const userId = Number(localStorage.getItem("user_id"));

    try {
      // ✅ VALIDATION - expense को include करें
      const errors = {};

      if (!ledgerType || (!party && !supplier && !imprestAccount && !transporter && !advanceWorker && !expense)) {
        errors.ledger = "Ledger name is required";
        toast.error("Please select a ledger name");
      }

      if (!methodOfPayment) {
        errors.method_of_payment = "Method of payment is required";
        toast.error("Please select a method of payment");
      }

      if (!paymentMode) {
        errors.payment_mode = "Payment mode is required";
        toast.error("Please select a payment mode");
      }

      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        setSubmitLoading(false);
        return;
      }

      const formData = new FormData();

      // ✅ Add all fields to formData
      const formFields = {
        payment_voucher_no: paymentVoucherNo,
        payment_number: paymentNumber,
        party,
        party_name: partyName,
        project,
        project_name: projectName,
        supplier,
        supplier_name: supplierName,
        imprest_account: imprestAccount,
        imprest_account_name: imprestAccountName,
        advance_worker: advanceWorker,
        advance_worker_name: advanceWorkerName,
        expense: expense, // ✅ EXPENSE FIELD ADD
        ledger_type: ledgerType,
        division,
        division_name: divisionName,
        cheque_date: chequeDate,
        payment_date: paymentDate,
        method_of_payment: methodOfPayment,
        voucher_type: voucherType,
        transporter,
        transporter_name: transporterName,
        total_amount: totalAmount,
        payment_mode: paymentMode,
        description,
        recommended_by,
        bank,
        narration,
        is_neft_rtgs: isNeftRtgs,
      };

      Object.keys(formFields).forEach(key => {
        if (formFields[key] !== null && formFields[key] !== "") {
          formData.append(key, formFields[key]);
        }
      });

      // ✅ Add NEFT/RTGS details only if checkbox is checked
      if (isNeftRtgs && showNeftRtgsDetails) {
        if (neftRtgsAccountNumber) formData.append("account_no", neftRtgsAccountNumber);
        if (neftRtgsIfscCode) formData.append("ifsc_code", neftRtgsIfscCode);
        if (neftRtgsBankName) formData.append("bank_name", neftRtgsBankName);
        if (neftRtgsBranchName) formData.append("branch_name", neftRtgsBranchName);
      }

      if (attachment instanceof File) {
        formData.append("attachment", attachment);
      }



      // ✅ For PURCHASE/JOURNAL type
      if (voucherType === "purchase" || voucherType === "journal") {
        const vouchersWithAdjust = selectedVouchers.filter(v => parseFloat(v.paid_amount) > 0);

        if (vouchersWithAdjust.length === 0) {
          toast.error("Please select at least one voucher and enter paid amount");
          setSubmitLoading(false);
          return;
        }

        const references = vouchersWithAdjust.map(v => ({
          purchase_voucher: v.type === "purchase" ? v.id : null,
          journal_voucher: v.type === "journal" ? v.id : null,
          paid_amount: parseFloat(v.paid_amount)
        }));

        formData.append("references", JSON.stringify(references));
        formData.append("total_amount", calculateTotalAdjustAmount());
      }

      if (editMode) {
        formData.append("updated_by", userId);
        await PaymentVoucherUpdate(currentEditId, formData);
        toast.success("Payment voucher updated successfully!");
      } else {
        formData.append("created_by", userId);
        await PaymentVoucherCreate(formData);
        toast.success("Payment voucher created successfully!");
      }

      // ✅ Reset form
      setExpenseRows([{ expense: "", amount: "" }]);
      setSelectedVouchers([]);
      setShowNeftRtgsDetails(false);
      setNeftRtgsAccountNumber("");
      setNeftRtgsIfscCode("");
      setNeftRtgsBankName("");
      setNeftRtgsBranchName("");
      if (!editMode) {
        generateVoucherNumber();
      }
      navigate("/dashboard/paymentvoucher");
      setFormErrors({});

    } catch (error) {
      console.error("Submit error:", error);
      if (error.response?.data) {
        const errorData = error.response.data;
        if (errorData.payment_number) {
          toast.error("Payment number already exists!");
        } else if (typeof errorData === 'object') {
          const firstError = Object.values(errorData)[0];
          toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
        } else {
          toast.error("Operation failed");
        }
      } else {
        toast.error("Operation failed");
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ✅ Buttons - Mobile Stack / Desktop Horizontal */}
      {isMobile ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2, px: 1 }}>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
            sx={{
              borderRadius: 0,
              height: 35,
              fontSize: "0.7rem",
              textTransform: "none",
            }}
          >
            ← Back
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={submitLoading}
            sx={{
              borderRadius: 0,
              height: 35,
              fontSize: "0.7rem",
              textTransform: "none",
            }}
          >
            {submitLoading ? "Submitting..." : editMode ? "Update" : "Submit"}
          </Button>
        </Box>
      ) : (
        <Grid container sx={{ mb: 2 }}>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 0,
                height: 35,
                minWidth: 120,
                fontSize: "0.7rem",
                textTransform: "none",
              }}
            >
              ← Back
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={submitLoading}
              sx={{
                borderRadius: 0,
                height: 35,
                minWidth: 140,
                fontSize: "0.7rem",
                textTransform: "none",
              }}
            >
              {submitLoading ? "Submitting..." : editMode ? "Update" : "Submit"}
            </Button>
          </Grid>
        </Grid>
      )}

      <Box sx={{ p: isMobile ? 1 : 3, maxWidth: 1400, mx: "auto" }}>
        <form onSubmit={handleSubmit}>
          <Card sx={{ mb: 3, backgroundColor: "#fff" }}>
            <CardContent>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Voucher No."
                    value={paymentNumber || ""}
                    size="small"
                    disabled
                    sx={{ "& .MuiInputBase-root": { height: 42 } }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={ledgerOptions}
                    getOptionLabel={(option) => option?.name || ""}
                    loading={ledgerLoading}
                    value={
                      selectedLedger ||
                      ledgerOptions.find((l) => {
                        if (ledgerType === "Party" && party) {
                          return l.id === party && l.type === "Party";
                        }
                        if (ledgerType === "Supplier" && supplier) {
                          return l.id === supplier && l.type === "Supplier";
                        }
                        if (ledgerType === "Imprest" && imprestAccount) {
                          return l.id === imprestAccount && l.type === "Imprest";
                        }
                        if (ledgerType === "AdvanceWorker" && advanceWorker) {
                          return l.id === advanceWorker && l.type === "AdvanceWorker";
                        }
                        if (ledgerType === "Transporter" && transporter) {
                          return l.id === transporter && l.type === "Transporter";
                        }
                        if (ledgerType === "Expense" && expense) {
                          return l.id === expense && l.type === "Expense";
                        }
                        return false;
                      }) ||
                      null
                    }
                    onChange={(e, newValue) => handleLedgerChange(newValue)}
                    inputValue={ledgerInputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      setLedgerInputValue(newInputValue);
                      if (reason === "input") {
                        debouncedLedgerSearch(newInputValue);
                      } else if (reason === "clear") {
                        debouncedLedgerSearch("");
                      }
                    }}
                    filterOptions={(x) => x}
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id && option?.type === value?.type
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Ledger Name *"
                        size="small"
                        error={!!formErrors.ledger}
                        helperText={formErrors.ledger}
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {ledgerLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={divisionLists || []}
                    getOptionLabel={(option) => option?.name || ""}
                    value={divisionLists.find((div) => div.id === division) || null}
                    onChange={(e, newValue) => handleDivisionChange(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Division"
                        size="small"
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={projectLists || []}
                    getOptionLabel={(option) => option?.name || ""}
                    value={projectLists.find((proj) => proj.id === project) || null}
                    onChange={(e, newValue) => handleProjectChange(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project"
                        size="small"
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <FormLabel
                      sx={{
                        fontWeight: 600,
                        mb: 1.5,
                        textAlign: "left",
                        display: "block",
                        color: "text.primary",
                      }}
                    >
                      Method of Payment *
                    </FormLabel>
                    <RadioGroup
                      row={!isMobile}
                      value={methodOfPayment || ""}
                      onChange={(e) => handlePaymentMethodChange(e.target.value)}
                      sx={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? 1 : 3,
                        mb: 2,
                      }}
                    >
                      <FormControlLabel
                        value="advance"
                        control={<Radio size="small" />}
                        label="Advance"
                      />
                      <FormControlLabel
                        value="against_reference"
                        control={<Radio size="small" />}
                        label="Against Reference"
                      />
                      <FormControlLabel
                        value="on_account"
                        control={<Radio size="small" />}
                        label="On Account"
                      />
                    </RadioGroup>
                    {formErrors.method_of_payment && (
                      <Typography variant="caption" color="error">
                        {formErrors.method_of_payment}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  {/* ADVANCE CONTENT */}
                  {methodOfPayment === "advance" && (
                    <Box sx={{ mt: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Advance Amount *"
                            type="number"
                            value={totalAmount || ""}
                            onChange={(e) => setTotalAmount(e.target.value)}
                            size="small"
                            inputProps={{ min: 0, step: 0.01 }}
                            sx={{ "& .MuiInputBase-root": { height: 42 } }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  )}

                  {methodOfPayment === "against_reference" && (
                    <Box sx={{ mt: -5 }}>
                      {(ledgerType === "Supplier" ||
                        ledgerType === "Imprest" ||
                        ledgerType === "AdvanceWorker") && (
                          <Grid container spacing={2}>
                            {ledgerType === "Supplier" && (
                              <Grid item xs={12}>
                                <FormControl fullWidth>
                                  <RadioGroup
                                    row={!isMobile}
                                    value={voucherType || ""}
                                    onChange={(e) => handleVoucherTypeChange(e.target.value)}
                                    sx={{
                                      flexDirection: isMobile ? "column" : "row",
                                      gap: isMobile ? 1 : 3,
                                    }}
                                  >
                                    {getVoucherTypeOptions(ledgerType).map((option) => (
                                      <FormControlLabel
                                        key={option.value}
                                        value={option.value}
                                        control={<Radio size="small" />}
                                        label={option.label}
                                      />
                                    ))}
                                  </RadioGroup>
                                </FormControl>
                              </Grid>
                            )}

                            {/* ✅ Purchase Voucher Table - Mobile Cards / Desktop Table */}
                            {voucherType === "purchase" && ledgerType === "Supplier" && (
                              <Grid item xs={12}>
                                <Box sx={{ mt: -2, p: isMobile ? 1 : 2, mr: isMobile ? 0 : 2 }}>
                                  {isMobile ? (
                                    // ✅ MOBILE VIEW - Cards
                                    <Box>
                                      {selectedVouchers.map((voucher, vIndex) => (
                                        <Box
                                          key={vIndex}
                                          sx={{
                                            mb: 2,
                                            p: 2,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#fafafa",
                                          }}
                                        >
                                          {/* Checkbox & Voucher No */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              mb: 2,
                                            }}
                                          >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                              <input
                                                type="checkbox"
                                                onChange={(e) =>
                                                  handleVoucherCheckboxChange(vIndex, e.target.checked)
                                                }
                                                style={{
                                                  width: "18px",
                                                  height: "18px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                              <strong>{voucher.voucher_no}</strong>
                                            </Box>
                                          </Box>

                                          {/* Details */}
                                          <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                              <Typography variant="caption" color="text.secondary">
                                                Total Amount
                                              </Typography>
                                              <Typography variant="body2" fontWeight="bold">
                                                ₹{voucher.total_amount.toFixed(2)}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Typography variant="caption" color="text.secondary">
                                                Remaining Amount
                                              </Typography>
                                              <Typography variant="body2" fontWeight="bold">
                                                ₹{voucher.remaining_amount.toFixed(2)}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <TextField
                                                fullWidth
                                                label="Pay Amount"
                                                type="number"
                                                value={voucher.paid_amount}
                                                onChange={(e) =>
                                                  handleAdjustAmountChange(vIndex, e.target.value)
                                                }
                                                size="small"
                                                inputProps={{
                                                  min: 0,
                                                  step: 0.01,
                                                  max: voucher.remaining_amount,
                                                }}
                                                sx={{ mt: 1 }}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Box>
                                      ))}

                                      {/* Total */}
                                      <Box
                                        sx={{
                                          mt: 2,
                                          p: 2,
                                          backgroundColor: "#f5f5f5",
                                          borderRadius: 1,
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <strong>Total Pay Amount:</strong>
                                        <strong>₹{calculateTotalAdjustAmount()}</strong>
                                      </Box>
                                    </Box>
                                  ) : (
                                    // ✅ DESKTOP VIEW - Table
                                    <>
                                      <TableContainer
                                        component={Paper}
                                        sx={{
                                          maxHeight: 400,
                                          overflowX: "auto",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: 1,
                                        }}
                                      >
                                        <Table
                                          stickyHeader
                                          size="small"
                                          sx={{
                                            minWidth: 850,
                                            "& td, & th": {
                                              textAlign: "center",
                                              whiteSpace: "nowrap",
                                              borderBottom: "1px solid #ccc",
                                            },
                                          }}
                                        >
                                          <TableHead
                                            sx={{
                                              "& th": {
                                                fontWeight: "bold",
                                                color: (theme) =>
                                                  theme.palette.mode === "dark" ? "#2196f3" : "#333",
                                                backgroundColor: (theme) =>
                                                  theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                                              },
                                            }}
                                          >
                                            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                              <TableCell>Select</TableCell>
                                              <TableCell>Voucher No</TableCell>
                                              <TableCell align="right">Total Amt</TableCell>
                                              <TableCell align="right">Rem Amt</TableCell>
                                              <TableCell align="right">Pay Amt</TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {selectedVouchers.map((voucher, vIndex) => (
                                              <TableRow
                                                key={vIndex}
                                                hover
                                                sx={{
                                                  backgroundColor:
                                                    vIndex % 2 === 0 ? "#fafafa" : "#ffffff",
                                                  "&:hover": {
                                                    backgroundColor: "#e3f2fd",
                                                    "& td": {
                                                      backgroundColor: "#e3f2fd !important",
                                                    },
                                                  },
                                                  "& td": {
                                                    paddingTop: "2px !important",
                                                    paddingBottom: "2px !important",
                                                    fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                                                    whiteSpace: "nowrap",
                                                    color: (theme) =>
                                                      theme.palette.mode === "dark"
                                                        ? "white"
                                                        : "inherit",
                                                    backgroundColor: (theme) =>
                                                      theme.palette.mode === "dark"
                                                        ? "black"
                                                        : "inherit",
                                                  },
                                                }}
                                              >
                                                <TableCell>
                                                  <input
                                                    type="checkbox"
                                                    onChange={(e) =>
                                                      handleVoucherCheckboxChange(
                                                        vIndex,
                                                        e.target.checked
                                                      )
                                                    }
                                                    style={{
                                                      width: "16px",
                                                      height: "16px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </TableCell>
                                                <TableCell>{voucher.voucher_no}</TableCell>
                                                <TableCell align="right">
                                                  ₹{voucher.total_amount.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                  ₹{voucher.remaining_amount.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                  <TextField
                                                    type="number"
                                                    value={voucher.paid_amount}
                                                    onChange={(e) =>
                                                      handleAdjustAmountChange(vIndex, e.target.value)
                                                    }
                                                    size="small"
                                                    inputProps={{
                                                      min: 0,
                                                      step: 0.01,
                                                      max: voucher.remaining_amount,
                                                    }}
                                                    sx={{
                                                      width: 100,
                                                      "& .MuiInputBase-root": {
                                                        height: 30,
                                                        fontSize: 10,
                                                        padding: 0,
                                                      },
                                                      "& input": {
                                                        padding: "4px 8px",
                                                      },
                                                    }}
                                                  />
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>

                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          width: "100%",
                                          mt: 2,
                                        }}
                                      >
                                        <TextField
                                          label="Total Pay Amount"
                                          value={`₹${calculateTotalAdjustAmount()}`}
                                          size="small"
                                          InputProps={{
                                            readOnly: true,
                                          }}
                                          inputProps={{
                                            style: { textAlign: "left" },
                                          }}
                                          sx={{
                                            width: 150,
                                            "& .MuiInputBase-root": {
                                              height: 35,
                                            },
                                          }}
                                        />
                                      </Box>
                                    </>
                                  )}
                                </Box>
                              </Grid>
                            )}

                            {/* ✅ Journal Voucher Table - Mobile Cards / Desktop Table */}
                            {voucherType === "journal" && (
                              <Grid item xs={12}>
                                <Box sx={{ mt: -2, p: isMobile ? 1 : 2 }}>
                                  {isMobile ? (
                                    // ✅ MOBILE VIEW - Cards
                                    <Box>
                                      {selectedVouchers.map((voucher, vIndex) => (
                                        <Box
                                          key={vIndex}
                                          sx={{
                                            mb: 2,
                                            p: 2,
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 1,
                                            backgroundColor: "#fafafa",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              mb: 2,
                                            }}
                                          >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                              <input
                                                type="checkbox"
                                                onChange={(e) =>
                                                  handleVoucherCheckboxChange(vIndex, e.target.checked)
                                                }
                                                style={{
                                                  width: "18px",
                                                  height: "18px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                              <strong>{voucher.voucher_no}</strong>
                                            </Box>
                                          </Box>

                                          {ledgerType === "Supplier" && (
                                            <Typography variant="body2" sx={{ mb: 1 }}>
                                              <strong>Bill No:</strong> {voucher.bill_no}
                                            </Typography>
                                          )}

                                          <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                              <Typography variant="caption" color="text.secondary">
                                                Total Amount
                                              </Typography>
                                              <Typography variant="body2" fontWeight="bold">
                                                ₹{voucher.total_amount.toFixed(2)}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Typography variant="caption" color="text.secondary">
                                                Remaining Amount
                                              </Typography>
                                              <Typography variant="body2" fontWeight="bold">
                                                ₹{voucher.remaining_amount.toFixed(2)}
                                              </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <TextField
                                                fullWidth
                                                label="Pay Amount"
                                                type="number"
                                                value={voucher.paid_amount}
                                                onChange={(e) =>
                                                  handleAdjustAmountChange(vIndex, e.target.value)
                                                }
                                                size="small"
                                                inputProps={{
                                                  min: 0,
                                                  step: 0.01,
                                                  max: voucher.remaining_amount,
                                                }}
                                                sx={{ mt: 1 }}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Box>
                                      ))}

                                      <Box
                                        sx={{
                                          mt: 2,
                                          p: 2,
                                          backgroundColor: "#f5f5f5",
                                          borderRadius: 1,
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <strong>Total Pay Amount:</strong>
                                        <strong>₹{calculateTotalAdjustAmount()}</strong>
                                      </Box>
                                    </Box>
                                  ) : (
                                    // ✅ DESKTOP VIEW - Table
                                    <>
                                      <TableContainer
                                        component={Paper}
                                        sx={{
                                          maxHeight: 400,
                                          overflowX: "auto",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: 1,
                                        }}
                                      >
                                        <Table
                                          size="small"
                                          stickyHeader
                                          sx={{
                                            minWidth: 850,
                                            "& td, & th": {
                                              textAlign: "center",
                                              whiteSpace: "nowrap",
                                              borderBottom: "1px solid #ccc",
                                            },
                                          }}
                                        >
                                          <TableHead>
                                            <TableRow
                                              sx={{
                                                backgroundColor: "#f5f5f5",
                                                "& th": {
                                                  fontWeight: "bold",
                                                  borderBottom: "1px solid #999",
                                                  backgroundColor: "#f5f5f5",
                                                },
                                              }}
                                            >
                                              <TableCell>Select</TableCell>
                                              <TableCell>Voucher No</TableCell>
                                              {ledgerType === "Supplier" && (
                                                <TableCell>Bill No</TableCell>
                                              )}
                                              <TableCell align="right">Total Amt</TableCell>
                                              <TableCell align="right">Rem Amt</TableCell>
                                              <TableCell align="right">Pay Amt</TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {selectedVouchers.map((voucher, vIndex) => (
                                              <TableRow
                                                hover
                                                key={vIndex}
                                                sx={{
                                                  backgroundColor:
                                                    vIndex % 2 === 0 ? "#fafafa" : "#ffffff",
                                                  "& td": {
                                                    paddingTop: "2px !important",
                                                    paddingBottom: "2px !important",
                                                    fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    maxWidth: 120,
                                                    backgroundColor: (theme) =>
                                                      theme.palette.mode === "dark"
                                                        ? "black"
                                                        : "inherit",
                                                    color: (theme) =>
                                                      theme.palette.mode === "dark"
                                                        ? "white"
                                                        : "inherit",
                                                  },
                                                  "&:hover": {
                                                    backgroundColor: "#e3f2fd !important",
                                                  },
                                                }}
                                              >
                                                <TableCell>
                                                  <input
                                                    type="checkbox"
                                                    onChange={(e) =>
                                                      handleVoucherCheckboxChange(
                                                        vIndex,
                                                        e.target.checked
                                                      )
                                                    }
                                                    style={{
                                                      width: "16px",
                                                      height: "16px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </TableCell>
                                                <TableCell>{voucher.voucher_no}</TableCell>
                                                {ledgerType === "Supplier" && (
                                                  <TableCell>{voucher.bill_no}</TableCell>
                                                )}
                                                <TableCell align="right">
                                                  ₹{voucher.total_amount.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                  ₹{voucher.remaining_amount.toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                  <TextField
                                                    type="number"
                                                    value={voucher.paid_amount}
                                                    onChange={(e) =>
                                                      handleAdjustAmountChange(vIndex, e.target.value)
                                                    }
                                                    size="small"
                                                    inputProps={{
                                                      min: 0,
                                                      step: 0.01,
                                                      max: voucher.remaining_amount,
                                                    }}
                                                    sx={{
                                                      width: 100,
                                                      "& .MuiInputBase-root": {
                                                        height: 30,
                                                        fontSize: 10,
                                                        padding: 0,
                                                      },
                                                      "& input": {
                                                        padding: "4px 8px",
                                                      },
                                                    }}
                                                  />
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>

                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          width: "100%",
                                          mt: 2,
                                        }}
                                      >
                                        <TextField
                                          label="Total Pay Amount"
                                          value={`₹${calculateTotalAdjustAmount()}`}
                                          size="small"
                                          InputProps={{
                                            readOnly: true,
                                          }}
                                          inputProps={{
                                            style: { textAlign: "left" },
                                          }}
                                          sx={{
                                            width: 150,
                                            "& .MuiInputBase-root": {
                                              height: 35,
                                            },
                                          }}
                                        />
                                      </Box>
                                    </>
                                  )}
                                </Box>
                              </Grid>
                            )}
                          </Grid>
                        )}
                    </Box>
                  )}

                  {methodOfPayment === "on_account" && (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Amount *"
                          type="number"
                          value={totalAmount || ""}
                          onChange={(e) => setTotalAmount(e.target.value)}
                          size="small"
                          inputProps={{ min: 0, step: 0.01 }}
                          sx={{ "& .MuiInputBase-root": { height: 42 } }}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} md={3}>
                  <FormControl fullWidth>
                    <FormLabel
                      sx={{ fontWeight: 600, mb: 1.5, textAlign: "left", display: "block" }}
                    >
                      Payment Mode *
                    </FormLabel>
                    <RadioGroup
                      value={paymentMode || ""}
                      onChange={(e) => setPaymentMode(e.target.value)}
                    >
                      <FormControlLabel
                        value="Cash"
                        control={<Radio size="small" />}
                        label="Cash"
                        sx={{ mb: 0.5 }}
                      />
                      <FormControlLabel
                        value="Bank"
                        control={<Radio size="small" />}
                        label="Bank"
                        sx={{ mb: 0.5 }}
                      />
                    </RadioGroup>
                    {formErrors.payment_mode && (
                      <Typography variant="caption" color="error">
                        {formErrors.payment_mode}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Payment Date"
                        InputLabelProps={{ shrink: true }}
                        type="date"
                        value={paymentDate || ""}
                        onChange={(e) => setPaymentDate(e.target.value)}
                        size="small"
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                        inputProps={{
                          max: new Date().toISOString().split("T")[0],
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Recommended By"
                        value={recommended_by || ""}
                        onChange={(e) => setRecommendedBy(e.target.value)}
                        size="small"
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                      />
                    </Grid>
                    {paymentMode === "Cash" && (
                      <>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Cash Details"
                            value={description || ""}
                            onChange={(e) => setDescription(e.target.value)}
                            size="small"
                            sx={{ "& .MuiInputBase-root": { height: 42 } }}
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            type="file"
                            onChange={(e) => setAttachment(e.target.files[0])}
                            label="Attachment"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            sx={{ "& .MuiInputBase-root": { height: 42 } }}
                          />
                        </Grid>
                      </>
                    )}

                    {paymentMode === "Bank" && (
                      <>
                        <Grid item xs={12} md={4}>
                          <Autocomplete
                            options={bankDetails}
                            getOptionLabel={(option) =>
                              `${option.bank_name || "Bank"} - ${option.account_number}`
                            }
                            value={bankDetails.find((bankItem) => bankItem.id === bank) || null}
                            onChange={(e, newValue) => {
                              setBank(newValue ? newValue.id : "");
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Bank Details *"
                                size="small"
                                sx={{ "& .MuiInputBase-root": { height: 42 } }}
                              />
                            )}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Check No/NEFT/RTGS/UPI"
                            value={description || ""}
                            onChange={(e) => setDescription(e.target.value)}
                            size="small"
                            sx={{ "& .MuiInputBase-root": { height: 42 } }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Check Date"
                            InputLabelProps={{ shrink: true }}
                            type="date"
                            value={chequeDate || ""}
                            onChange={(e) => setChequeDate(e.target.value)}
                            size="small"
                            sx={{ "& .MuiInputBase-root": { height: 42 } }}
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            type="file"
                            onChange={(e) => setAttachment(e.target.files[0])}
                            label="Attachment"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            sx={{ "& .MuiInputBase-root": { height: 42 } }}
                          />
                        </Grid>

                        {/* ✅ NEFT/RTGS CHECKBOX */}
                        <Grid item xs={12} md={2}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={showNeftRtgsDetails}
                                onChange={handleNeftRtgsCheckboxChange}
                                size="small"
                              />
                            }
                            label="NEFT/RTGS"
                            sx={{
                              height: 42,
                              display: "flex",
                              alignItems: "center",
                              ml: 1,
                            }}
                          />
                        </Grid>

                        {/* ✅ NEFT/RTGS DETAILS FIELDS */}
                        {showNeftRtgsDetails && (
                          <>
                            <Grid item xs={12} md={3}>
                              <TextField
                                fullWidth
                                label="Account Number"
                                value={neftRtgsAccountNumber}
                                onChange={(e) => setNeftRtgsAccountNumber(e.target.value)}
                                size="small"
                                sx={{ "& .MuiInputBase-root": { height: 42 } }}
                              />
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <TextField
                                fullWidth
                                label="IFSC Code"
                                value={neftRtgsIfscCode}
                                onChange={(e) => setNeftRtgsIfscCode(e.target.value)}
                                size="small"
                                sx={{ "& .MuiInputBase-root": { height: 42 } }}
                              />
                            </Grid>

                            <Grid item xs={12} md={3}>
                              <TextField
                                fullWidth
                                label="Bank Name"
                                value={neftRtgsBankName}
                                onChange={(e) => setNeftRtgsBankName(e.target.value)}
                                size="small"
                                sx={{ "& .MuiInputBase-root": { height: 42 } }}
                              />
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <TextField
                                fullWidth
                                label="Branch Name"
                                value={neftRtgsBranchName}
                                onChange={(e) => setNeftRtgsBranchName(e.target.value)}
                                size="small"
                                sx={{ "& .MuiInputBase-root": { height: 42 } }}
                              />
                            </Grid>
                          </>
                        )}
                      </>
                    )}

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Narration"
                        value={narration || ""}
                        onChange={(e) => setNarration(e.target.value)}
                        size="small"
                        multiline
                        rows={2}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </form>
      </Box>
    </>
  );

};

export default PaymentVoucherForm;